'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _GroupedDictionary = require('./classes/GroupedDictionary');

var _GroupedDictionary2 = _interopRequireDefault(_GroupedDictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _GroupedDictionary2.default({
  Aerospace: {
    AEROSPACE_MILITARY_AIRCRAFT: 'Military Aircraft',
    AEROSPACE_MISSILES: 'Missiles',
    AEROSPACE_SPACE: 'Space',
    AEROSPACE_COMMERCIAL_AIRLINES: 'Commercial Airlines',
    AEROSPACE_GENERAL_AVIATION: 'General Aviation',
    AEROSPACE_AUTOMOTIVE: 'Automotive'
  },
  Agricultural: {
    AGRICULTURAL_LIVESTOCK: 'Livestock',
    AGRICULTURAL_FISHERIES: 'Fisheries',
    AGRICULTURAL_MAJOR_CROPS: 'Major crops (wheat, cotton, sugar, rice etc.)',
    AGRICULTURAL_MINOR_CROPS: 'Minor crops',
    AGRICULTURAL_FORESTRY: 'Forestry'
  },
  'Arts, Entertainment, and Recreation': {
    PERFORMING_ARTS: 'Performing Arts',
    SPECTATOR_SPORTS: 'Spectator Sports',
    MUSEUMS: 'Museums',
    HISTORICAL_SITES: 'Historical Sites',
    AMUSEMENT: 'Amusement',
    GAMBLING: 'Gambling'
  },
  Automotive: {
    AUTOMOTIVE_RIDE_SHARING: 'Ride Sharing'
  },
  Beverage: {
    BEVERAGE_DISTILLED_SPIRITS: 'Distilled Spirits'
  },
  Chemical: {
    CHEMICAL_ORGANIC_MATERIALS: 'Organic materials',
    CHEMICAL_INORGANIC_MATERIALS: 'Inorganic materials',
    CHEMICAL_MARKET_BASED: 'Market-based (e.g. petrochemicals or plastics)'
  },
  'Communication Services': {
    DIVERSIFIED_TELECOMMUNICATION: 'Diversified Telecommunication',
    ENTERTAINMENT: 'Entertainment',
    INTERACTIVE_MEDIA_SERVICES: 'Interactive Media & Services',
    MEDIA: 'Media',
    WIRELESS_TELECOMMUNICATION: 'Wireless Telecommunication'
  },
  'Classic Cars': {
    VINTAGE_CARS: 'Vintage Cars',
    LUXURY_CARS: 'Luxury Cars',
    ANTIQUE_CARS: 'Antique Cars'
  },
  Consumer: {
    AUTOMOBILE_COMPONENTS: 'Automobile Components',
    AUTOMOBILES: 'Automobiles',
    DISTRIBUTORS: 'Distributors',
    DIVERSIFIED_CONSUMER_SERVICES: 'Diversified Consumer Services',
    HOTELS_RESTAURANTS_LEISURE: 'Hotels, Restaurants & Leisure',
    HOUSEHOLD_DURABLES: 'Household Durables',
    LEISURE_PRODUCTS: 'Leisure Products',
    MULTILINE_RETAIL: 'Multiline Retail',
    SPECIALTY_RETAIL: 'Specialty Retail',
    TEXTILE_APPAREL_LUXURY_GOODS: 'Textile, Apparel & Luxury Goods',
    INTERNET_DIRECT_MARKETING: 'Internet & Direct Marketing'
  },
  Education: {
    EDUCATION_PRE_COLLEGIATE: 'Pre collegiate',
    EDUCATION_JUNIOR_COLLEGIATE: 'Junior collegiate',
    EDUCATION_COLLEGIATE: 'Collegiate',
    EDUCATION_BUSINESS_SCHOOL_COMPUTER_MGMT_TRAINING: 'Business schools and Computer & Management training',
    EDUCATION_TRADE_SCHOOLS: 'Trade schools',
    EDUCATION_SERVICES: 'Education services'
  },
  Energy: {
    ENERGY_UPSTREAM: 'Upstream',
    ENERGY_MIDSTREAM: 'Midstream',
    ENERGY_DOWNSTREAM: 'Downstream',
    ENERGY_OFS: 'OFS',
    ENERGY_INFRASTRUCTURE_NATURAL_RESOURCES: 'Infrastructure / Natural Resources',
    ENERGY_POWER_RENEWABLES: 'Power / Renewables',
    ENERGY_EQUIPMENT_SERVICES: 'Energy Equipment & Services',
    LNG: 'LNG',
    POWER_UTILITIES: 'Power & Utilities',
    METAL_MINING: 'Metal Mining',
    GOLD_SILVER_ORES: 'Gold and Silver Ores',
    MINERALS_ROYALTIES: 'Minerals and Royalties',
    WORKING_INTEREST: 'Working Interest'
  },
  'Financial Services': {
    FINANCIAL_SERVICES_COMMERCIAL_BANKING: 'Commercial banking',
    FINANCIAL_SERVICES_INVESTMENT_BANKING: 'Investment banking',
    FINANCIAL_SERVICES_FOREIGN_EXCHANGE_SERVICES: 'Foreign exchange services',
    FINANCIAL_SERVICES_INVESTMENT_SERVICES: 'Investment services',
    FINANCIAL_SERVICES_INSURANCE: 'Insurance',
    FINANCIAL_SERVICES_EXPORTS: 'Financial Exports',
    FINANCIAL_SERVICES_ACCOUNTANCY: 'Accountancy',
    CAPITAL_MARKETS: 'Capital Markets',
    CONSUMER_FINANCE: 'Consumer Finance',
    DIVERSIFIED_FINANCIAL_SERVICES: 'Diversified Financial Services',
    MORTGAGE_REAL_ESTATE_INVESTMENT_TRUSTS: 'Mortgage Real Estate Investment Trusts (REITs)',
    THRIFTS_MORTGAGE_FINANCE: 'Thrifts & Mortgage Finance'
  },
  Fintech: {
    FINTECH_ECOMMERCE: 'E-commerce',
    FINTECH_ELECTRONIC_PAYMENT: 'Electronic Payment',
    FINTECH_CRYPTO_EXCHANGE: 'Crypto Exchange',
    FINTECH_STOCK_BROKERAGE: 'Stock Brokerage',
    FINTECH_BLOCKCHAIN: 'Blockchain'
  },
  Funds: {
    HEDGE_FUNDS: 'Hedge Funds',
    PRIVATE_EQUITY_FUNDS: 'Private Equity Funds',
    VENTURE_CAPITAL_FUNDS: 'Venture Capital Funds',
    REAL_ESTATE_FUNDS: 'Real Estate Funds',
    INFRASTRUCTURE_FUNDS: 'Infrastructure Funds',
    MINERALS_INTEREST_FUND: 'Natural Resources Funds',
    CREDIT_FUNDS: 'Credit Funds'
  },
  Healthcare: {
    HEALTHCARE_PHARMACEUTICAL_BIOTECH: 'Pharmaceutical/Biotech',
    HEALTHCARE_MEDICAL_EQUIPMENT: 'Medical equipment',
    HEALTHCARE_MANAGED_HEALTHCARE: 'Managed healthcare',
    HEALTHCARE_FACILITIES: 'Healthcare facilities',
    HEALTHCARE_MEDICAL_TECH: 'Medical tech',
    HEALTHCARE_DEVICES_DIAGNOSTICS: 'Devices and Diagnostics',
    BIOTECH: 'Biotech',
    HEALTH_CARE_EQUIPMENT_SUPPLIES: 'Health Care Equipment & Supplies',
    HEALTH_CARE_PROVIDERS_SERVICES: 'Health Care Providers & Service',
    HEALTH_CARE_TECHNOLOGY_INDUSTRY: 'Health Care Technology Industry',
    LIFE_SCIENCES_TOOLS_SERVICES: 'Life Sciences Tools & Services',
    PHARMACEUTICAL: 'Pharmaceutical',
    HEALTH_SERVICES: 'Health Services',
    OFFICES_CLINICS_DOCTORS_MEDICINE: 'Offices & Clinics of Doctors of Medicine',
    NURSING_PERSONAL_CARE_FACILITIES: 'Nursing & Personal Care Facilities',
    SKILLED_NURSING_CARE_FACILITIES: 'Skilled Nursing Care Facilities',
    HOSPITALS: 'Hospitals',
    GENERAL_MEDICAL_SURGICAL_HOSPITALS: 'General Medical & Surgical Hospitals',
    MEDICAL_LABORATORIES: 'Medical Laboratories',
    HOME_HEALTH_CARE: 'Home Health Care',
    MISCELLANEOUS_HEALTH_ALLIED_SERVICES: 'Miscellaneous Health & Allied Services',
    SPECIALTY_OUTPATIENT_FACILITIES: 'Specialty Outpatient Facilities'
  },
  'Healthcare IT': {
    HEALTHCARE_IT_ANALYTICS: 'Analytics',
    HEALTHCARE_IT_DIGITAL_HEALTH: 'Digital Health',
    HEALTHCARE_IT_ENTERPRISE_SOFTWARE: 'Enterprise Software'
  },
  'Healthcare and Social Assistance': {
    AMBULATORY_HEALTH_CARE: 'Ambulatory Health Care',
    HOSPITALS: 'Hospitals',
    NURSING_RESIDENTIAL_CARE_FACILITIES: 'Nursing and Residential Care Facilities',
    SOCIAL_ASSISTANCE: 'Social Assistance'
  },
  Hospitality: {
    HOSPITALITY_FOOD_BEVERAGES: 'Food & Beverages',
    HOSPITALITY_TRAVEL_TOURISM: 'Travel & Tourism',
    HOSPITALITY_LODGING: 'Lodging',
    HOSPITALITY_RECREATION: 'Recreation'
  },
  Industrials: {
    AEROSPACE_DEFENSE: 'Aerospace & Defense',
    AIR_FREIGHT_LOGISTICS: 'Air Freight & Logistics',
    AIRLINES_INDUSTRY: 'Airlines Industry',
    BUILDING_PRODUCTS: 'Building Products',
    COMMERCIAL_SERVICES_SUPPLIES: 'Commercial Services & Supplies',
    CONSTRUCTION_ENGINEERING: 'Construction & Engineering',
    ELECTRICAL_EQUIPMENT: 'Electrical Equipment',
    INDUSTRIAL_CONGLOMERATES: 'Industrial Conglomerates',
    MACHINERY: 'Machinery',
    MARINE: 'Marine',
    PROFESSIONAL_SERVICES: 'Professional Services',
    ROAD_RAIL: 'Road & Rail',
    TRADING_COMPANIES_DISTRIBUTORS: 'Trading Companies & Distributors',
    TRANSPORTATION_INFRASTRUCTURE: 'Transportation Infrastructure'
  },
  'Information Technology': {
    COMMUNICATIONS_EQUIPMENT: 'Communications Equipment',
    ELECTRONIC_EQUIPMENT_INSTRUMENTS_COMPONENTS: 'Electronic Equipment, Instruments & Components',
    IT_SERVICES: 'IT Services',
    SEMICONDUCTORS_SEMICONDUCTOR_EQUIPMENT: 'Semiconductors & Semiconductor Equipment',
    SOFTWARE: 'Software',
    TECHNOLOGY_HARDWARE_STORAGE_PERIPHERALS: 'Technology Hardware, Storage & Peripherals'
  },
  Jewelry: {
    GOLD: 'Gold',
    DIAMONDS: 'Diamonds',
    RUBIES: 'Rubies',
    PLATINUM: 'Platinum',
    PRECIOUS_STONES: 'Precious Stones',
    GOLD_DIAMOND_RUBIES: 'Gold, Diamond, and Rubies'
  },
  Manufacturing: {
    MANUFACTURING_FOOD: 'Food - NAICS 311',
    MANUFACTURING_BEVERAGE_TOBACCO: 'Beverage and Tobacco',
    MANUFACTURING_TEXTILE_MILLS: 'Textile Mills',
    MANUFACTURING_TEXTILE_PRODUCT_MILLS: 'Textile Product Mills',
    MANUFACTURING_APPAREL: 'Apparel',
    MANUFACTURING_LEATHER_ALLIED: 'Leather and Allied Product',
    MANUFACTURING_WOOD: 'Wood Product',
    MANUFACTURING_PAPER: 'Paper',
    MANUFACTURING_PRINTING: 'Printing and Related Support Activities',
    MANUFACTURING_PETROLEUM_COAL: 'Petroleum and Coal Product',
    MANUFACTURING_CHEMICAL: 'Chemical',
    MANUFACTURING_PLASITCS_RUBBER: 'Plastics and Rubber Product',
    MANUFACTURING_NONMETALIC_MINERAL: 'Nonmetallic Mineral Product',
    MANUFACTURING_PRIMARY_METAL: 'Primary Metal',
    MANUFACTURING_FABRICATED_METAL: 'Fabricated Metal Product',
    MANUFACTURING_MACHINERY: 'Machinery',
    MANUFACTURING_COMPUTER_ELECTRONIC: 'Computer and Electronic Product',
    MANUFACTURING_ELECTRICAL_EQUIPMENT_APPLIANCE_COMPONENT: 'Electrical Equipment, Appliance, and Component',
    MANUFACTURING_TRANSPORTATION: 'Transportation Equipment',
    MANUFACTURING_FURNITURE: 'Furniture and Related Product',
    MANUFACTURING_MISCELLANEOUS: 'Miscellaneous'
  },
  Materials: {
    CHEMICALS: 'Chemicals',
    CONSTRUCTION_MATERIALS: 'Construction Materials',
    CONTAINERS_PACKAGING: 'Containers & Packaging',
    METALS_MINING: 'Metals & Mining',
    PAPER_FOREST_PRODUCTS: 'Paper & Forest Products'
  },
  Media: {
    MEDIA_PUBLISHING: 'Publishing',
    MEDIA_INTERACTIVE: 'Interactive media',
    MEDIA_TELEVISION: 'Television',
    MEDIA_FILM: 'Film',
    MEDIA_RADIO: 'Radio',
    MEDIA_GAMING: 'Gaming',
    PUBLISHING: 'Publishing',
    MOTION_PICTURE_SOUND_RECORDING: 'Motion Picture and Sound Recording',
    BROADCASTING: 'Broadcasting',
    TELECOMMUNICATIONS: 'Telecommunications',
    DATA_PROCESSING_HOSTING_RELATED_SERVICES: 'Data Processing, Hosting, and Related Services',
    OTHER_MEDIA_SERVICES: 'Other Media Services'
  },
  Mining: {
    MINING_GOLD_SILVER_ORES: 'Gold and Silver Ores',
    MINING_GOLD: 'Gold',
    MINING_SILVER: 'Silver',
    MINING_METAL: 'Metal',
    MINING_IRON: 'Iron',
    MINING_COPPER: 'Copper'
  },
  'Public Utilities': {
    PUBLIC_UTILITIES_GAS_POWER: 'Gas and Power',
    PUBLIC_UTILITIES_ELECTRIC: 'Electric',
    PUBLIC_UTILITIES_WATER: 'Water',
    PUBLIC_UTILITIES_INTEGRATED_PROVIDERS: 'Integrated Providers',
    INDEPENDENT_POWER_RENEWABLE_ELECTRICITY_PRODUCERS: 'Independent Power and Renewable Electricity Producers',
    MULTI_UTILITIES: 'Multi-Utilities'
  },
  'Real Estate': {
    REAL_ESTATE_COMMERCIAL: 'Commercial',
    REAL_ESTATE_INDUSTRIAL: 'Industrial',
    REAL_ESTATE_REIT: 'REIT',
    REAL_ESTATE_RESIDENTIAL_MULTIFAMILY: 'Residential & Multifamily',
    REAL_ESTATE_INTERNATIONAL: 'International',
    RENTAL_LEASING_SERVICES: 'Rental and Leasing Services',
    EQUITY_REAL_ESTATE_INVESTMENT_TRUSTS: 'Equity Real Estate Investment Trusts',
    REAL_ESTATE_MANAGEMENT_DEVELOPMENT: 'Real Estate Management & Development',
    REAL_ESTATE_OPERATORS: 'Real Estate Operators (No Developers) & Lessors',
    REAL_ESTATE_DEALERS: 'Real Estate Dealers',
    LAND_SUBDIVIDERS_DEVELOPERS: 'Land Subdividers & Developers',
    BLANK_CHECKS: 'Blank Checks',
    OIL_ROYALTY_TRADERS: 'Oil Royalty Traders',
    PATENT_OWNERS_LESSORS: 'Patent Owners & Lessors',
    MINERAL_ROYALTY_TRADERS: 'Mineral Royalty Traders',
    INVESTORS: 'Investors',
    HOTELS_ROOMING_HOUSES_CAMPS_OTHER_LODGING_PLACES: 'Hotels, Rooming Houses, Camps & Other Lodging Places',
    HOTELS_MOTELS: 'Hotels & Motels'
  },
  Retail: {
    MOTOR_VEHICLE_PARTS: 'Motor Vehicle and Parts',
    FURNITURE_HOME_FURNISHINGS: 'Furniture and Home Furnishings',
    ELECTRONICS_APPLIANCE: 'Electronics and Appliance',
    BUILDING_MATERIAL: 'Building Material',
    GARDEN_EQUIPMENT: 'Garden Equipment',
    SUPPLIES: 'Supplies',
    FOOD_BEVERAGE: 'Food and Beverage',
    HEALTH_PERSONAL_CARE: 'Health and Personal Care',
    GASOLINE_STATIONS: 'Gasoline Stations',
    CLOTHING_CLOTHING_ACCESSORIES: 'Clothing and Clothing Accessories',
    SPORTING_GOODS_HOBBY_MUSICAL_INSTRUMENT_BOOKS: 'Sporting Goods, Hobby, Musical Instrument, and Books',
    GENERAL_MERCHANDISE: 'General Merchandise',
    MISCELLANEOUS: 'Miscellaneous'
  },
  Technology: {
    TECHNOLOGY_FINTECH: 'FinTech',
    TECHNOLOGY_ENERGYTECH: 'EnergyTech',
    TECHNOLOGY_CLEANTECH: 'CleanTech',
    TECHNOLOGY_CONSUMER: 'Consumer',
    TECHNOLOGY_SOFTWARE: 'Software',
    TECHNOLOGY_ICO: 'Initial Coin Offering (ICO)',
    TECHNOLOGY_OTHER: 'Other',
    COMPUTER_PROGRAMMING_DATA_PROCESSING_ETC: 'Computer Programming, Data Processing, etc',
    COMPUTER_PROGRAMMING_SERVICES: 'Computer Programming Services',
    PREPACKAGED_SOFTWARE: 'Prepackaged Software',
    COMPUTER_INTEGRATED_SYSTEMS_DESIGN: 'Computer Integrated Systems Design',
    COMPUTER_PROCESSING_DATA_PREPARATION: 'Computer Processing & Data Preparation'
  },
  'Trade and Services': {
    LEGAL: 'Legal',
    EDUCATIONAL: 'Educational',
    SOCIAL: 'Social',
    CHILD_DAY_CARE: 'Child Day Care',
    MEMBERSHIP_ORGANIZATIONS: 'Membership organizations',
    ENGINEERING_ACCOUNTING_RESEARCH_MANAGEMENT: 'Engineering, Accounting, Research, Management',
    ENGINEERING: 'Engineering',
    COMMERCIAL_PHYSICAL_BIOLOGICAL_RESEARCH: 'Commercial Physical & Biological Research',
    MANAGEMENT: 'Management',
    MANAGEMENT_CONSULTING_SERVICES: 'Management Consulting Services',
    FACILITIES_SUPPORT_MANAGEMENT_SERVICES: 'Facilities Support Management Services',
    COMPUTER_RENTAL_LEASING: 'Computer Rental & Leasing',
    BUSINESS_SERVICES: 'Business Services',
    DETECTIVE_GUARD_ARMORED_CAR_SERVICES: 'Detective, Guard & Armored Car Services',
    PHOTOFINISHING_LABORATORIES: 'Photofinishing laboratories',
    TELEPHONE_INTERCONNECT_SYSTEMS: 'Telephone interconnect systems',
    AUTOMOTIVE_REPAIR_SERVICES_PARKING: 'Automotive repair, services & parking',
    AUTO_RENTAL_LEASING: 'Auto rental & leasing (no drivers)',
    MISCELLANEOUS_REPAIR_SERVICES: 'Miscellaneous Repair services',
    MOTION_PICTURE_VIDEO_TAPE_PRODUCTION: 'Motion Picture & Video Tape Production',
    ALLIED_TO_MOTION_PICTURE_PRODUCTION: 'Allied to Motion Picture Production',
    MOTION_PICTURE_THEATERS: 'Motion Picture Theaters',
    AMUSEMENT_RECREATION_SERVICES: 'Amusement & Recreation Services',
    SERVICES_RACING_INCLUDING_TRACK_OPERATION: 'Services-racing, including track operation',
    MEMBERSHIP_SPORTS_RECREATION_CLUBS: 'Membership Sports & Recreation Clubs'
  },
  Transportation: {
    TRANSPORTATION_AIR: 'Air',
    TRANSPORTATION_RAIL: 'Rail',
    TRANSPORTATION_WATER: 'Water',
    TRANSPORTATION_TRUCK: 'Truck',
    TRANSPORTATION_TRANSIT_GROUND_PASSENGER: 'Transit and Ground Passenger',
    TRANSPORTATION_PIPELINE: 'Pipeline',
    TRANSPORTATION_SCENIC_SIGHTSEEING: 'Scenic and Sightseeing',
    TRANSPORTATION_SUPPORT_ACTIVITIES: 'Support Activities',
    TRANSPORTATION_POSTAL_SERVICE: 'Postal Service',
    TRANSPORTATION_COURIERS_MESSENGERS: 'Couriers and Messengers',
    TRANSPORTATION_WAREHOUSING: 'Warehousing and Storage'
  }
});